import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

// Screens
import Landing from "./screens/Landing.jsx";
import ChatButton from "./components/Buttons/ChatButton.jsx";
import Loader from "./components/Elements/Loader.jsx";
import Footer from "./components/Sections/Footer.jsx";
import Header from "./components/Sections/Header.jsx";
import TopNavbar from "./components/Nav/TopNavbar.jsx";
import AboutUs from "./components/Sections/AboutUs.jsx";
import Services from "./components/Sections/Services.jsx";
import Contact from "./components/Sections/Contact.jsx";

export default function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => setLoading(false), 3000); // Simulate a loader
  }, []);

  return (
    <React.Fragment>
      <Helmet>
        {/* Global Helmet tags: apply to all pages */}
        <title>Pak Maid Service | Reliable Maid Services in Pakistan</title>
        <meta
          name="description"
          content="Book reliable and professional maid services in Pakistan. Pak Maid Service offers 24/7 availability, weekly & monthly packages."
        />
        <meta name="keywords" content="maid service Pakistan, house cleaning, Lahore, Karachi, Islamabad maids" />
        <meta name="robots" content="index, follow" />
        <meta name="author" content="Pak Maid Service" />
        <link rel="canonical" href="https://pakmaidservice.com/" />
        

        {/* Open Graph for social sharing */}
        <meta property="og:title" content="Pak Maid Service | Reliable Maids" />
        <meta property="og:description" content="Professional and trusted maid services available 24/7 across Pakistan." />
        <meta property="og:image" content="https://pakmaidservice.com/your-og-image.jpg" />
        <meta property="og:url" content="https://pakmaidservice.com" />
        <meta property="og:type" content="website" />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Pak Maid Service" />
        <meta name="twitter:description" content="Book trusted maid services in Pakistan - available 24/7." />
        <meta name="twitter:image" content="https://pakmaidservice.com/your-og-image.jpg" />

        {/* Fonts Preload */}
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="true" />
        <link
          href="https://fonts.googleapis.com/css2?family=Khula:wght@400;600;800&display=swap"
          rel="stylesheet"
        />
      </Helmet>

      {loading ? (
        <Loader />
      ) : (
        <Router>
          <TopNavbar />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/about" element={<AboutUs />} />
            <Route path="/services" element={<Services />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
          <Footer />
          <ChatButton />
        </Router>
      )}
    </React.Fragment>
  );
}
